import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../../asset/Header/Navbar.module.scss";
import Logo from "../../asset/homefour/logo.svg";

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const navRef = useRef(null);

  // Outside click close
  useEffect(() => {
    const handleOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <header className={styles.navbar}>
      <div className={styles.paddingheader} ref={navRef}>
        {/* Logo */}
        <div className={styles.logo}>
          <img src={Logo} alt="Logo" />
        </div>

        {/* Hamburger */}
        <div
          className={`${styles.hamburger} ${open ? styles.active : ""}`}
          onClick={() => setOpen(!open)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Menu */}
        <nav className={`${styles.menu} ${open ? styles.open : ""}`}>
          <Link to="/" onClick={closeMenu} className={location.pathname === "/" ? styles.active : ""}>Home</Link>
          <Link to="/about" onClick={closeMenu} className={location.pathname === "/about" ? styles.active : ""}>About</Link>
          <Link to="/service" onClick={closeMenu} className={location.pathname === "/service" ? styles.active : ""}>Services</Link>
          <Link to="/portfolio" onClick={closeMenu} className={location.pathname.startsWith("/portfolio") ? styles.active : ""}>Portfolio</Link>
          <Link to="/clients" onClick={closeMenu} className={location.pathname === "/clients" ? styles.active : ""}>Clients</Link>
          <Link to="/contact" onClick={closeMenu} className={location.pathname === "/contact" ? styles.active : ""}>Contact</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
